module.exports = __webpack_public_path__ + "img/Dyeing.3e43861f.png";